export default __webpack_public_path__ + "support-ee-poster.60262137553d9446d0cf.png";